import React, { useState, useContext, useEffect, useRef } from 'react';
import UserContext from '../context/UserContext';
import { apiClient } from '../api/client';
import { setAuthToken } from '../auth/authStorage';
import { getApiErrorMessage } from '../api/private';
import seePass from '../images/seePassword.png';
import defUser from '../images/defaultuser.jpg';
import '../Login.css';
import minilogo from '../images/Kopia_STOCK_SLEUTH-removebg-preview-1.png';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  NavLink,
  useParams,
  useNavigate
} from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';
import { completeGoogleSignIn, getGoogleAuthErrorMessage } from '../api/googleAuth';
import '../newstyles.css';


const SignUp = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordC, setPasswordC] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [privacyAcknowledged, setPrivacyAcknowledged] = useState(false);
  const [age16OrOlder, setAge16OrOlder] = useState(false);
  const [guardianPermissionIfUnder18, setGuardianPermissionIfUnder18] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordC, setShowPasswordC] = useState(false);
  const imageRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
      // If the current path is "/scanner", don't show the search bar
      useEffect(() => {
      console.log("runs");
      const handleResize = () => {
      console.log("handling");
        const mobile = window.innerWidth <= 768;
        setIsMobile(mobile);
        if (mobile) {
        console.log("mobile");
        
        } else {
        console.log("desktop");
        
      }
      };
      
      // Invoke handleResize on component mount
      handleResize();
      
      // Add event listener for window resize
      window.addEventListener('resize', handleResize);
      
      // Cleanup event listener on component unmount
      return () => window.removeEventListener('resize', handleResize);
      }, []);
  const [image, setImage] = useState(null);
  const handleTogglePassword = () => {
		setShowPassword(!showPassword);
	};
	const handleTogglePasswordC = () => {
		setShowPasswordC(!showPasswordC);
	};
	
	const handleImageChange = (e) => {
  const file = e.target.files[0];

  if (file) {
    const reader = new FileReader();

    reader.onload = async (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Set the canvas dimensions to your desired size, e.g., 128x128
        canvas.width = 128;
        canvas.height = 128;

        // Draw the image on the canvas with the desired size
        ctx.drawImage(img, 0, 0, 128, 128);

        // Convert the canvas content to a Blob object (compressed image file)
        canvas.toBlob((blob) => {
          setImage(blob);
        }, 'image/jpeg', 0.7);
      };
    };

    reader.readAsDataURL(file);
  }
};

	const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setPasswordError('');
      if (!termsAccepted || !privacyAcknowledged || !age16OrOlder || !guardianPermissionIfUnder18) {
        setPasswordError('Please complete the Terms, privacy, and age confirmations.');
        return;
      }
      await completeGoogleSignIn({ credentialResponse, persistent: rememberMe, setUser, navigate, legalVersions: { termsVersion: '2026-09-14', privacyVersion: '2026-09-14', age16OrOlder, guardianPermissionIfUnder18 } });
    } catch (error) {
      setPasswordError(error.message === 'MISSING_GOOGLE_CREDENTIAL'
        ? 'Google did not return a valid credential. Please try again.'
        : getGoogleAuthErrorMessage(error));
    }
  };

  const handleSignUp = async (event) => {
  event?.preventDefault();
  if (!termsAccepted || !privacyAcknowledged || !age16OrOlder || !guardianPermissionIfUnder18) {
    setPasswordError('Please complete the Terms, privacy, and age confirmations.');
    return;
  }
  // Email validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setEmailError('Invalid email address');
    return;
  } else {
    setEmailError('');
  }

  // Password strength check
  if (password.length < 8) {
    setPasswordError('Password must be at least 8 characters long');
    return;
  } else {
    setPasswordError('');
  }

  // Check if password and confirm password match
  if (password !== passwordC) {
    setPasswordError('Passwords do not match');
    return;
  } else {
    setPasswordError('');
  }

  try {
    // Create a FormData object to handle file uploads
    const formData = new FormData();
    formData.append('username', username);
    formData.append('email', email);
    formData.append('password', password);
	formData.append('termsVersion', '2026-09-14');
	formData.append('privacyVersion', '2026-09-14');
	formData.append('age16OrOlder', 'true');
	formData.append('guardianPermissionIfUnder18', 'true');
	
    if (image) {
    formData.append('image', image);
	  } else {
		// Append the default user image
		const defaultImageBlob = await fetch(defUser).then((res) => res.blob());
		formData.append('image', defaultImageBlob, 'defaultuser.jpg');
	  }
    // Make an API request to the signup endpoint in your Node.js backend running locally
    const response = await apiClient.post('/auth/signup', formData, { skipAuth: true });
	const imageUrl = response.data.profile_image;
	if (response.data.profile_image !== null) {
    }
    if (rememberMe) {
      // Set the cookie with a longer expiration time (30 days)
      setAuthToken(response.data.token, { persistent: true });
    }

    // Once signed up, set the user in the context
    setUser({ ...response.data});
  } catch (error) {
    setPasswordError(getApiErrorMessage(error));
  }
};


  return (
    <div style = {{ textAlign: "center", alignItems: 'center',justifyContent: 'center', width: '100vw', height: '100vh', display: 'flex', background: '#FFF'}}>
		<NavLink to="/" className="logo" style={{top: 18, left:20}}>
          <div className="overlap-5">
          <div className="text-wrapper-7">
            StockSleuth
          </div>
          <img className="kopia-STOCK-SLEUTH" alt="Kopia STOCK SLEUTH" src={minilogo} />
          </div>
        </NavLink>
        {!isMobile ? (<>
		<div className="AlreadyAccount">
			<h3 className="SignInTo">Sign Up for</h3>
			<h4 className="YourAcc">A StockSleuth Account</h4>
			<p className="text1">If you already have an account,</p>
			<p className="text2">You can <span style={{color: '#4D47C3', fontWeight: '600'}}><Link to="/SignIn" style={{color: '#4D47C3', fontWeight: '600', textDecoration: 'none'}}>Login here !</Link></span></p>
			{/*<img className="person" src={saly}/>*/}
		</div>
		
		<div className="signInForm">
			<h2 className = "LoginHeader" style = {{margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left'}}>Sign Up</h2>
			
			<div className = "EmailInputUp">
			<input className="EmailPlaceholder2" name="email" autoComplete="email" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
			</div>
			
			<div className = "UsernameInputUp">
			<input className='UserPlaceholder' name="username" autoComplete="username" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type='text' placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
			
			</div>
			
			<div className = "PasswordInputUp">
			<input className='passPlaceholder' name="new-password" autoComplete="new-password" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
			<img onClick={handleTogglePassword} style={{position: 'absolute',top: '23px', right: '32px'}} src={seePass} />
			</div>
			
			<div className = "ConfirmPasswordInputUp">
			<input className='passPlaceholder' name="confirm-password" autoComplete="new-password" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type={showPasswordC ? 'text' : 'password'} placeholder="Confirm Password" value={passwordC} onChange={(e) => setPasswordC(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSignUp(e); }} />
			<img onClick={handleTogglePasswordC} style={{position: 'absolute',top: '23px', right: '32px'}} src={seePass} />
			</div>
			
			{passwordError && <p style={{ color: 'black' }}>{passwordError}</p>}
			<label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12 }}><input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />Keep me signed in</label>
			<div className="signupLegalChecks">
			  <label><input type="checkbox" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />I accept the <Link to="/terms" target="_blank">Terms of Service</Link>.</label>
			  <label><input type="checkbox" checked={privacyAcknowledged} onChange={(e) => setPrivacyAcknowledged(e.target.checked)} />I have read the <Link to="/privacy" target="_blank">Privacy Policy</Link>.</label>
			  <label><input type="checkbox" checked={age16OrOlder} onChange={(e) => setAge16OrOlder(e.target.checked)} />I am at least 16 years old.</label>
			  <label><input type="checkbox" checked={guardianPermissionIfUnder18} onChange={(e) => setGuardianPermissionIfUnder18(e.target.checked)} />If I am under 18, I have permission from a parent or guardian.</label>
			</div>
			<div className="SignUpButton"onClick={handleSignUp}><p className="LogIn"style={{margin: '0px'}}>Create An Account</p></div>
			<p className="ContinueWith">or continue with</p>
			<GoogleLogin onSuccess={handleGoogleSuccess} onError={() => setPasswordError('Google sign-in failed. Please try again.')} />{/*
			<path d="M39.4108 21.1315C39.4108 19.6402 39.2873 18.5519 39.02 17.4234H21.6434V24.1543H31.8431C31.6375 25.8271 30.5271 28.3462 28.0593 30.0389L28.0247 30.2643L33.5189 34.4354L33.8996 34.4727C37.3954 31.3086 39.4108 26.6533 39.4108 21.1315Z" fill="#4285F4"/>
			<path d="M21.6422 38.8662C26.6392 38.8662 30.8342 37.2539 33.8984 34.4728L28.0581 30.0391C26.4953 31.1072 24.3977 31.8528 21.6422 31.8528C16.748 31.8528 12.5941 28.6889 11.1133 24.3157L10.8963 24.3338L5.18338 28.6667L5.10867 28.8702C8.15212 34.7952 14.4036 38.8662 21.6422 38.8662Z" fill="#34A853"/>
			<path d="M11.1144 24.3158C10.7237 23.1873 10.4976 21.978 10.4976 20.7286C10.4976 19.479 10.7237 18.2699 11.0939 17.1414L11.0835 16.901L5.29899 12.4986L5.10973 12.5868C3.85537 15.0455 3.13562 17.8064 3.13562 20.7286C3.13562 23.6508 3.85537 26.4116 5.10973 28.8703L11.1144 24.3158Z" fill="#FBBC05"/>
			<path d="M21.6423 9.60422C25.1176 9.60422 27.4619 11.0754 28.7986 12.3048L34.0219 7.30685C30.814 4.38469 26.6393 2.59108 21.6423 2.59108C14.4037 2.59108 8.15214 6.66192 5.10867 12.5868L11.0928 17.1414C12.5941 12.7683 16.7481 9.60422 21.6423 9.60422Z" fill="#EB4335"/>
			*/}
		</div>
    </>) : (<>
    
    
   
		
		<div className="signInForm" style={{right: "auto", marginTop: -120}}>
			<h2 className = "LoginHeader" style = {{margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left'}}>Sign Up</h2>
			
			<div className = "EmailInputUp">
			<input className="EmailPlaceholder2" name="email" autoComplete="email" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
			</div>
			
			<div className = "UsernameInputUp">
			<input className='UserPlaceholder' name="username" autoComplete="username" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type='text' placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
			
			</div>
			
			<div className = "PasswordInputUp">
			<input className='passPlaceholder' name="new-password" autoComplete="new-password" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
			<img onClick={handleTogglePassword} style={{position: 'absolute',top: '23px', right: '32px'}} src={seePass} />
			</div>
			
			<div className = "ConfirmPasswordInputUp">
			<input className='passPlaceholder' name="confirm-password" autoComplete="new-password" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type={showPasswordC ? 'text' : 'password'} placeholder="Confirm Password" value={passwordC} onChange={(e) => setPasswordC(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSignUp(e); }} />
			<img onClick={handleTogglePasswordC} style={{position: 'absolute',top: '23px', right: '32px'}} src={seePass} />
			</div>
			
			{passwordError && <p style={{ color: 'black' }}>{passwordError}</p>}
			<label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12 }}><input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />Keep me signed in</label>
			<div className="signupLegalChecks">
			  <label><input type="checkbox" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />I accept the <Link to="/terms" target="_blank">Terms of Service</Link>.</label>
			  <label><input type="checkbox" checked={privacyAcknowledged} onChange={(e) => setPrivacyAcknowledged(e.target.checked)} />I have read the <Link to="/privacy" target="_blank">Privacy Policy</Link>.</label>
			  <label><input type="checkbox" checked={age16OrOlder} onChange={(e) => setAge16OrOlder(e.target.checked)} />I am at least 16 years old.</label>
			  <label><input type="checkbox" checked={guardianPermissionIfUnder18} onChange={(e) => setGuardianPermissionIfUnder18(e.target.checked)} />If I am under 18, I have permission from a parent or guardian.</label>
			</div>
			<div className="SignUpButton"onClick={handleSignUp}><p className="LogIn"style={{margin: '0px'}}>Create An Account</p></div>
			<p className="ContinueWith">or continue with</p>
			<GoogleLogin onSuccess={handleGoogleSuccess} onError={() => setPasswordError('Google sign-in failed. Please try again.')} />{/*
			<path d="M39.4108 21.1315C39.4108 19.6402 39.2873 18.5519 39.02 17.4234H21.6434V24.1543H31.8431C31.6375 25.8271 30.5271 28.3462 28.0593 30.0389L28.0247 30.2643L33.5189 34.4354L33.8996 34.4727C37.3954 31.3086 39.4108 26.6533 39.4108 21.1315Z" fill="#4285F4"/>
			<path d="M21.6422 38.8662C26.6392 38.8662 30.8342 37.2539 33.8984 34.4728L28.0581 30.0391C26.4953 31.1072 24.3977 31.8528 21.6422 31.8528C16.748 31.8528 12.5941 28.6889 11.1133 24.3157L10.8963 24.3338L5.18338 28.6667L5.10867 28.8702C8.15212 34.7952 14.4036 38.8662 21.6422 38.8662Z" fill="#34A853"/>
			<path d="M11.1144 24.3158C10.7237 23.1873 10.4976 21.978 10.4976 20.7286C10.4976 19.479 10.7237 18.2699 11.0939 17.1414L11.0835 16.901L5.29899 12.4986L5.10973 12.5868C3.85537 15.0455 3.13562 17.8064 3.13562 20.7286C3.13562 23.6508 3.85537 26.4116 5.10973 28.8703L11.1144 24.3158Z" fill="#FBBC05"/>
			<path d="M21.6423 9.60422C25.1176 9.60422 27.4619 11.0754 28.7986 12.3048L34.0219 7.30685C30.814 4.38469 26.6393 2.59108 21.6423 2.59108C14.4037 2.59108 8.15214 6.66192 5.10867 12.5868L11.0928 17.1414C12.5941 12.7683 16.7481 9.60422 21.6423 9.60422Z" fill="#EB4335"/>
			*/}
      <p className="text1" style={{marginTop: '20px', color: '#B5B5B5'}}>If you already have an account,</p>
			<p className="text2" style={{color: '#B5B5B5'}}>You can <span style={{color: '#4D47C3', fontWeight: '600'}}><Link to="/SignIn" style={{color: '#4D47C3', fontWeight: '600', textDecoration: 'none'}}>Login here !</Link></span></p>
			
		</div>
    
    </>)}
		
		
    </div>
  );
};

export default SignUp;
